import axiosInstance from "@/api/axiosInstance";
import { useAuthStore } from "@/store/AuthStore";
import { useNotifications } from "@/services/useNotifications";

export function useAuthService() {
  const authStore = useAuthStore();

  const isLoggedIn = async (): Promise<boolean> => {
    try {
      return true;
    } catch (error) {
      console.error("Token validation error:", error);
      return false;
    }
  };

  const adminLogin = async (email: string, password: string): Promise<any> => {
    // No try/catch: the login view tells bad credentials from an unverified address from a
    // dead backend, and it can only do that if the axios error reaches it intact.
    const response = await axiosInstance.post("/admin/login", {
      email,
      password,
    });
    authStore.role = response.data.role;
    return response.data;
  };

  const customerLogin = async (
    email: string,
    password: string
  ): Promise<any> => {
    // No try/catch: the login view tells bad credentials from an unverified address from a
    // dead backend, and it can only do that if the axios error reaches it intact.
    const response = await axiosInstance.post("/login", {
      email,
      password,
    });
    authStore.role = response.data.role;
    return response.data;
  };

  const logout = async (): Promise<void> => {
    await axiosInstance.post("/api/v1/logout");
    // Otherwise one user's notifications survive into the next session in the same tab.
    const { disconnect, reset } = useNotifications();
    disconnect();
    reset();
    authStore.role = "";
    authStore.firstName = "";
    authStore.lastName = "";
    authStore.username = "";
  };

  return {
    isLoggedIn,
    adminLogin,
    customerLogin,
    logout,
  };
}
